export const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  // Custom warning message
  event.preventDefault();
  // For modern browsers
  event.returnValue;
};

export const handlePostState = () => {
  // Prevent the user from going back when clicking the browser back button pressed
  window.addEventListener('popstate', () => {
    window.history.pushState(null, '', '#');
  });
  window.history.pushState(null, '', '#');
};
